import { NgModule } from '@angular/core';

import { GroupCollectionEffects } from './GroupCollectionEffects';
import { GroupFormEffects } from './GroupFormEffects';

@NgModule({
  providers: [GroupCollectionEffects, GroupFormEffects],
})
export class GroupEffectsModule {}
